// QA check with HW

import {RestApiService} from '../../../rest-api.service';
import {Observable} from "rxjs";
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {DeviceDataCsvImportRequest, DeviceDataRequest, DeviceDataRes,} from '../../../../contracts/v0/contracting/device-data.contracts';
import {ApiV0Contracting} from '../api.v0.contracting';

export class ApiV0DeviceData {
    segment: string;

    constructor(v0: ApiV0Contracting, private rest: RestApiService) {
        this.segment = v0.segment + '/deviceData';
    }

    list(): Observable<BaseCollectionModel<DeviceDataRes>> {
        return this.rest.get<BaseCollectionModel<DeviceDataRes>>(`${this.segment}/list`, DeviceDataRes)
    }

    search(searchModel?: SearchModel): Observable<BaseCollectionModel<DeviceDataRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<DeviceDataRes>>(`${this.segment}/search`, DeviceDataRes, searchModel)
    }

    detail(guid: string): Observable<DeviceDataRes> {
        return this.rest.get(`${this.segment}/details/${guid}`, DeviceDataRes)
    }

    create(createRequest: DeviceDataRequest) {
        return this.rest.post<DeviceDataRequest, DeviceDataRes>(`${this.segment}/create`, DeviceDataRes, createRequest)
    }

    update(updateRequest: DeviceDataRequest) {
        return this.rest.patch<DeviceDataRequest, DeviceDataRes>(`${this.segment}/update`, DeviceDataRes, updateRequest)
    }

    delete(guid: string) {
        return this.rest.delete<void>(`${this.segment}/delete/${guid}`)
    }

    importCsvData(data: DeviceDataCsvImportRequest): Observable<BaseCollectionModel<DeviceDataRes>> {
        return this.rest.post<DeviceDataCsvImportRequest, BaseCollectionModel<DeviceDataRes>>(
            `${this.segment}/import/csv`,
            DeviceDataRes,
            data
        )
    }

    importExcelData(data: DeviceDataCsvImportRequest): Observable<BaseCollectionModel<DeviceDataRes>> {
        return this.rest.post<DeviceDataCsvImportRequest, BaseCollectionModel<DeviceDataRes>>(
            `${this.segment}/import/excel`,
            DeviceDataRes,
            data
        )
    }

    cpuArchitectureSelectionList(): Observable<BaseCollectionModel<string>> {
        return this.rest.get<BaseCollectionModel<string>>(`${this.segment}/cpuArchitectureSelectionList`)
    }

    kernelTypeSelectionList(): Observable<BaseCollectionModel<string>> {
        return this.rest.get<BaseCollectionModel<string>>(`${this.segment}/kernelTypeSelectionList`)
    }

    productTypeSelectionList(): Observable<BaseCollectionModel<string>> {
        return this.rest.get<BaseCollectionModel<string>>(`${this.segment}/productTypeSelectionList`)
    }
}

